import { all, takeLatest, call, put } from 'redux-saga/effects';

import { apiFetchSiteInfo } from '@dragonfruit/services/apis';

import {
  FETCH_SITE_INFO,
  fetchSiteInfoSuccess,
  fetchSiteInfoFailure,
} from '@dragonfruit/redux/siteInfo';

export function* fetchSiteInfoFlow() {
  try {
    const {
      faq,
      offering,
      multipleOfferingMode,
      regularClassCampaignLinks,
      courseCampaignLinks,
      activityLinks,
      showInstructorBtn,
    } = yield call(apiFetchSiteInfo);
    const { webFooter: zendeskFAQLink } = faq;

    yield put(
      fetchSiteInfoSuccess({
        zendeskFAQLink,
        offerings: offering,
        multipleOfferingMode,
        showInstructorBtn,
        campaignLinks: {
          regularClass: regularClassCampaignLinks,
          course: courseCampaignLinks,
          activity: activityLinks,
        },
      })
    );
  } catch (err) {
    yield put(fetchSiteInfoFailure());
  }
}

export default function*() {
  yield all([takeLatest(FETCH_SITE_INFO, fetchSiteInfoFlow)]);
}



// WEBPACK FOOTER //
// ./app/sagas/siteInfo.js